import useTranslation from 'next-translate/useTranslation'
import { memo } from 'react'

import Icon from '@/atoms/Icon'
import dayjs from '@/helpers/dayjs'

function Header({ orderDate }: HeaderProps) {
  const { t } = useTranslation('customer')

  const date = dayjs(orderDate).format('DD.MM.YYYY, HH:mm')

  return (
    <h3 className="flex flex-col justify-between space-y-2 leading-snug md:space-y-0 md:flex-row">
      <span className="flex items-center justify-center space-x-2 leading-snug xs:space-x-3">
        <Icon
          className="flex-shrink-0 w-5 mt-px xs:block"
          name="shopping_bag"
        />
        <span className="text-xl font-medium">
          {t('order_from_short', { date })}
        </span>
      </span>
    </h3>
  )
}

interface HeaderProps {
  orderDate: Date | string
}

export default memo(Header)
